import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'

import { getAccessToken } from '@driftt/web-auth'

import config from 'config'
import LoadingPage from 'layouts/LoadingPage'
import { setVideoSignupReferrer } from 'utils/trackingUtils'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(null, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      // If you have a token already, head to the login page
      if (getAccessToken()) {
        window.location.replace(`${config.DRIFT_VIDEO_HOMEPAGE}`)
      } else {
        window.localStorage.removeItem('drift_video_webstore_referrer')
        setVideoSignupReferrer({
          source: 'extension-sign-in',
          location: 'extension-sign-in',
        })

        // Enforcing manual delay to allow LS value to be set
        setTimeout(() => {
          this.props.actions.push('/video/start')
        }, 250)
      }
    },
  })
)(LoadingPage)
